import { createSlice } from '@reduxjs/toolkit';

import { appReducers } from './reducers/app.reducers';
import { crossDashboardReducers } from './reducers/crossDashboard.reducers';
import { dashboardEditInitialState, sessionReducers } from './reducers/session.reducers';
import { tabReducers } from './reducers/tab.reducers';
import { tileReducers } from './reducers/tile.reducers';

const initialState = dashboardEditInitialState;

const dashboardEditSlice = createSlice({
  name: 'dashboardEdit',
  initialState,
  reducers: {
    ...sessionReducers,
    ...tabReducers,
    ...appReducers,
    ...tileReducers,
    ...crossDashboardReducers
  }
});

export const {
  initializeDraft,
  resetDraft,
  resetToEmpty,
  markDirty,
  renameDashboard,
  setAllDashboardsData,
  setCurrentTab,
  addTab,
  renameTab,
  deleteTab,
  reorderTabs,
  addApp,
  removeApp,
  renameAppTab,
  updateAppTab,
  reorderApps,
  addTabToApp,
  removeTabFromApp,
  moveTabBetweenApps,
  reorderTabsInsideApp,
  updateCurrentTabApps,
  removeEmptyApps,
  addTile,
  removeTile,
  updateTile,
  reorderTiles,
  updateCurrentTabTiles,
  setInsertPosition,
  createDashboardDraft,
  initializeOtherDashboardDraft,
  moveAppToOtherDashboard,
  moveTileToOtherDashboard,
  moveAppTabToOtherDashboard,
  moveTabToOtherDashboard,
  ensureTabExistsInOtherDashboard
} = dashboardEditSlice.actions;

export default dashboardEditSlice.reducer;
